import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '@environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AppInsightsService {
    appInsights: ApplicationInsights;

    constructor(@Inject(PLATFORM_ID) private platformId: string) {}

    init(appInsightsId?: string): void {
        if (!isPlatformBrowser(this.platformId)) return;

        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: appInsightsId ?? environment.appInsightsId,
                enableAutoRouteTracking: true, // option to log all route changes
            },
        });
        this.appInsights.loadAppInsights();
    }

    logEvent(name: string, properties?: { [key: string]: any }): void {
        if (!isPlatformBrowser(this.platformId)) return;
        this.appInsights.trackEvent({ name }, properties);
    }

    logException(exception: Error, severityLevel?: number): void {
        this.appInsights.trackException({ exception, severityLevel });
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
        this.appInsights.trackMetric({ name, average }, properties);
    }

    logPageView(name?: string, url?: string): void {
        // option to call manually
        this.appInsights.trackPageView({
            name,
            uri: url,
        });
    }

    logTrace(message: string, properties?: { [key: string]: any }): void {
        this.appInsights.trackTrace({ message }, properties);
    }
}
